import { AlertMessage } from '../../../../../../shared/AlertMessage';
import { Budget } from '../../../../../../@types/budget';

interface Props {
  budget: Budget | null;
  onClose: () => void;
  onDelete: () => void;
}

export const DeleteModal = ({ budget, onClose, onDelete }: Props) => {
  return (
    <AlertMessage.Root
      isOpen
      onClose={onClose}
      title="Excluir Orçamento?"
      footer={
        <AlertMessage.Footer>
          <>
            <AlertMessage.ConfirmButton onClick={onClose}>
              Revisar
            </AlertMessage.ConfirmButton>
            <AlertMessage.CancelButton
              onClick={() => {
                onDelete();
                onClose();
              }}
            >
              Excluir
            </AlertMessage.CancelButton>
          </>
        </AlertMessage.Footer>
      }
    >
      <AlertMessage.Body>
        <p>
          O Orçamento: <b>{budget?.BUDGET ?? ''}</b> será excluído
        </p>
      </AlertMessage.Body>
    </AlertMessage.Root>
  );
};
